export default `/* Ids Tooltip Component - Most Styles are in Popup */
:host {
  display: none;
}

:host([visible]) {
  display: inline;
}

.ids-popup.tooltip.standalone {
  position: relative;
}

ids-popup[dir=rtl]::part(arrow)::after, ids-popup[dir=rtl]::part(arrow-top)::after, ids-popup[dir=rtl]::part(arrow-right)::after, ids-popup[dir=rtl]::part(arrow-bottom)::after, ids-popup[dir=rtl]::part(arrow-left)::after {
  display: none;
}

ids-popup[arrow=top]::part(arrow-left)::after {
  display: none;
}

.adjust-whitespace {
  white-space: pre-wrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdG9vbHRpcCIsInNvdXJjZXMiOlsiaWRzLXRvb2x0aXAuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUlGO0VBQ0U7OztBQUtBO0VBS0U7OztBQUtGO0VBQ0U7OztBQUlKO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgVG9vbHRpcCBDb21wb25lbnQgLSBNb3N0IFN0eWxlcyBhcmUgaW4gUG9wdXAgKi9cbjpob3N0IHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuOmhvc3QoW3Zpc2libGVdKSB7XG4gIGRpc3BsYXk6IGlubGluZTtcbn1cblxuLy8gVXNlZCBmb3IgcG9zaXRpb25pbmcgSWRzVG9vbHRpcHMgaW4gc3RhbmRhbG9uZS1jc3MgbW9kZVxuLmlkcy1wb3B1cC50b29sdGlwLnN0YW5kYWxvbmUge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG5cbi8vIEFkanVzdCBTdHVmZiBmb3IgUlRMXG5pZHMtcG9wdXBbZGlyPSdydGwnXSB7XG4gICY6OnBhcnQoYXJyb3cpOjphZnRlcixcbiAgJjo6cGFydChhcnJvdy10b3ApOjphZnRlcixcbiAgJjo6cGFydChhcnJvdy1yaWdodCk6OmFmdGVyLFxuICAmOjpwYXJ0KGFycm93LWJvdHRvbSk6OmFmdGVyLFxuICAmOjpwYXJ0KGFycm93LWxlZnQpOjphZnRlciB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG5pZHMtcG9wdXBbYXJyb3c9J3RvcCddIHtcbiAgJjo6cGFydChhcnJvdy1sZWZ0KTo6YWZ0ZXIge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLmFkanVzdC13aGl0ZXNwYWNlIHtcbiAgd2hpdGUtc3BhY2U6IHByZS13cmFwO1xufVxuIl19 */`;
